export default __webpack_public_path__ + "static/media/mano_mano.74b88b1f.jpg";